import React from 'react'
import { Tag } from 'antd'
import { LinkOutlined } from '@ant-design/icons'
import { OverflowTooltip } from 'components/OverflowToolTip/OverflowTooltip'

export interface CommercialSupportCellProps {
  support?: { id?: string, name?: string }
  canEditCommercial: boolean
  onOpenModal: () => void
}

function CommercialSupportCell ({ support, canEditCommercial, onOpenModal }: CommercialSupportCellProps) {
  const linked = Boolean(support?.name)

  if (!linked) {
    if (canEditCommercial) {
      return (
        <OverflowTooltip width={100}>
          <Tag
            icon={<LinkOutlined />}
            className="commercial-support-cell commercial-support-cell--unlinked pointer mb-0"
            onClick={onOpenModal}
          >
            Vincular
          </Tag>
        </OverflowTooltip>
      )
    }

    return (
      <Tag className="commercial-support-cell commercial-support-cell--empty mb-0">
        Sem suporte
      </Tag>
    )
  }

  if (canEditCommercial) {
    return (
      <OverflowTooltip width={100}>
        <span
          className="link-style color-tertiary font-500 mb-0 table-name"
          onClick={onOpenModal}
        >
          {support?.name}
        </span>
      </OverflowTooltip>
    )
  }

  return (
    <OverflowTooltip width={100}>
      <span className="table-name">{support?.name}</span>
    </OverflowTooltip>
  )
}

export default CommercialSupportCell
